// "Watch trailer": abre o trailer (com som) num diálogo acessível (Radix: foco preso, Esc fecha, devolve o foco).
// O vídeo só é pedido ao abrir (preload="none" até lá nem existe no DOM).
import { MEDIA_FILES, mediaUrl } from "@ecliptica/config/media";
import { useTranslation } from "@ecliptica/i18n";
import { Button, Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle, DialogTrigger } from "@ecliptica/ui";
import { Play } from "lucide-react";
import { HERO_POSTER } from "./HeroVideo";

export function TrailerButton() {
  const { t } = useTranslation();
  return (
    <Dialog>
      <DialogTrigger asChild>
        <Button size="lg">
          <Play aria-hidden className="size-4" />
          {t("hero.trailer")}
        </Button>
      </DialogTrigger>
      <DialogContent className="max-w-4xl gap-3 p-4 sm:p-5">
        <DialogHeader>
          <DialogTitle>{t("hero.trailerTitle")}</DialogTitle>
          <DialogDescription className="sr-only">{t("hero.trailerDesc")}</DialogDescription>
        </DialogHeader>
        <video controls autoPlay playsInline preload="auto" poster={HERO_POSTER} className="aspect-video w-full rounded-md bg-black">
          <source src={mediaUrl(MEDIA_FILES.trailer)} type="video/mp4" />
        </video>
      </DialogContent>
    </Dialog>
  );
}
